import { getSport } from "@/sports";

// [yards toward the middle (+) / sideline (-), yards forward (+) / back (-)]
export const ROUTE_PRESETS = {
  straight: { label: "Straight", pts: [[0, 10]] },
  slant: { label: "Slant", pts: [[0, 3], [6, 8]] },
  in: { label: "In", pts: [[0, 6], [8, 6]] },
  out: { label: "Out", pts: [[0, 6], [-7, 6]] },
  post: { label: "Post", pts: [[0, 8], [6, 16]] },
  corner: { label: "Corner", pts: [[0, 8], [-6, 15]] },
  hitch: { label: "Hitch/Curl", pts: [[0, 6], [1, 4.5]] },
  zigzag: { label: "Zigzag", pts: [[-3, 4], [3, 8], [-3, 12]] },
  backpedal: { label: "Backpedal & Break", pts: [[0, -5], [4, -1]] },
};

export function presetPoints(play, player, key) {
  const cx = getSport(play.sport).centerX;
  const fwd = player.side === "offense" ? -1 : 1;
  const inward = player.x < cx ? 1 : -1;
  const r1 = (v) => Math.round(v * 10) / 10;
  return ROUTE_PRESETS[key].pts.map(([lat, f]) => ({ x: r1(Math.min(52.8, Math.max(0.5, player.x + lat * inward))), y: r1(player.y + f * fwd) }));
}
